import { Box, Switch, Typography } from "@mui/material";
import React from "react";

const SkillInsights = ({
	newAddOnSettings,
	setNewAddOnSettings,
}: any) => {
	const skillInsightsEnabled = newAddOnSettings.skillInsightsEnabled;

	return (
		<Box
			sx={{
				marginTop: "20px",
				marginBottom: "8px",
				borderRadius: "8px",
				border: 1,
				borderWidth: "1px",
				borderColor: "rgba(0,0,0,0.12)",
				background: "#FFF",
				padding: "16px",
			}}
		>
			<Box
				sx={{
					display: "flex",
					justifyContent: "space-between",
					padding: "0px 16px",
					alignItems: "center",
				}}
			>
				<Box sx={{
					display: "flex",
					flexDirection: "column",
				}}>
					<Typography
						sx={{
							fontFamily: "Roboto",
							fontWeight: 400,
							fontSize: "16px",
							color: "rgba(0, 0, 0, 0.87)",
						}}
					>
						Enable Skill Insights
					</Typography>
					<Typography
						sx={{
							fontFamily: "Roboto",
							fontWeight: 400,
							fontSize: "12px",
							color: "rgba(0, 0, 0, 0.6)",
						}}
					>
						Show the Summary tab in Cross-Skilling and the Skill Summary report
						under Reports.
					</Typography>
				</Box>
				<Switch
					checked={skillInsightsEnabled ?? false}
					onChange={(e) => {
						setNewAddOnSettings((pre: any) => {
							return {
								...pre,
								skillInsightsEnabled: e.target.checked,
							};
						});
					}}
				/>
			</Box>
		</Box>
	);
};

export default SkillInsights;
